import { format, parseISO } from "date-fns";
import type { Tester } from "../types";

interface TestingNotStartedPageProps {
  profile: Tester;
  startDateISO: string;
  contactEmail: string;
}

export function TestingNotStartedPage({
  profile,
  startDateISO,
  contactEmail,
}: TestingNotStartedPageProps) {
  const startDate = startDateISO ? parseISO(startDateISO) : null;
  const startLabel = startDate ? format(startDate, "EEEE, MMMM d") : "Soon";
  const cohortLabel =
    profile.tester_type === "Volunteer" ? "Volunteer testing" : "Staff testing";

  return (
    <div className="min-h-screen bg-[#fafaf7] flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center">
        <div className="text-xs font-bold tracking-widest text-rwb-red mb-2">TEAM RWB</div>
        <h1 className="text-2xl font-semibold text-zinc-900 mb-3">Testing begins soon</h1>
        <p className="text-sm text-zinc-500 mb-6">
          Welcome, {profile.first_name}.
        </p>

        <div className="rounded-lg bg-white border border-zinc-200 p-5 text-left">
          <div className="text-[10px] uppercase tracking-wider text-zinc-400 mb-1">
            {cohortLabel} starts
          </div>
          <div className="text-lg font-semibold text-zinc-900 mb-3">{startLabel}</div>
          <div className="text-xs text-zinc-500 leading-relaxed">
            Until then, you can pair your wearable and join your assigned challenges in the
            Activity Tracking app. We'll email you a reminder the day before testing kicks
            off.
          </div>
        </div>

        <p className="text-[11px] text-zinc-400 mt-6">
          Questions? Email <strong className="font-semibold">{contactEmail}</strong>.
        </p>
      </div>
    </div>
  );
}
